import * as API from '../api'
import * as formatPreRegistrationToSend from '../utils/formatPreRegistrationToSend'

export const ADD_PRE_REGISTRATION = 'ADD_PRE_REGISTRATION'
export const CHANGE_ORDER_COLUMN = 'CHANGE_ORDER_COLUMN'
export const CHANGE_ORDER_DIRECTION = 'CHANGE_ORDER_DIRECTION'
export const CHANGE_PAGE = 'CHANGE_PAGE'
export const CHANGE_PER_PAGE = 'CHANGE_PER_PAGE'
export const CHANGE_PRE_REGISTRATION = 'CHANGE_PRE_REGISTRATION'
export const CLOSE_MODAL = 'CLOSE_MODAL'
export const DELETE_PRE_REGISTRATION = 'DELETE_PRE_REGISTRATION'
export const EDIT_PRE_REGISTRATION = 'EDIT_PRE_REGISTRATION'
export const FETCH_PRE_REGISTRATION = 'FETCH_PRE_REGISTRATION'
export const FETCH_PRE_REGISTRATION_ERROR = 'FETCH_PRE_REGISTRATION_ERROR'
export const FETCH_PRE_REGISTRATIONS = 'FETCH_PRE_REGISTRATIONS'
export const FETCH_PRE_REGISTRATIONS_ERROR = 'FETCH_PRE_REGISTRATIONS_ERROR'
export const FETCHING_PRE_REGISTRATION = 'FETCHING_PRE_REGISTRATION'
export const FETCHING_PRE_REGISTRATIONS = 'FETCHING_PRE_REGISTRATIONS'
export const FORM_TOUCHED = 'FORM_TOUCHED'
export const NEW_FORM_PRE_REGISTRATION = 'NEW_FORM_PRE_REGISTRATION'
export const OPEN_MODAL = 'OPEN_MODAL'
export const PRE_REGISTRATION_FORM_ERROR = 'PRE_REGISTRATION_FORM_ERROR'
export const RESET_STATE = 'RESET_STATE'

export const openModal = () => {
  return dispatch => {
    dispatch({ type: OPEN_MODAL })
  }
}

export const handleChangePreRegistration = preRegistration => {
  return dispatch => {
    dispatch({ type: CHANGE_PRE_REGISTRATION, preRegistration })
  }
}

const getInvalidField = errorMessage => {
  const [x, field = ''] = /validation failed: (.*):/.exec(errorMessage) || [] // eslint-disable-line
  return field
}

export const handlePreRegistrationError = (res, dispatch) => {
  const { data: errorMessage = '' } = res

  switch (true) {
    case errorMessage.includes('validation failed'):
      dispatch({
        type: FORM_TOUCHED
      })

      dispatch({
        type: PRE_REGISTRATION_FORM_ERROR,
        field: getInvalidField(errorMessage),
        message: `${getInvalidField(errorMessage)} é inválido.`
      })

      return Promise.reject(res)
    default:
      break
  }
}

export const newFormPreRegistration = preRegistration => {
  return dispatch => {
    dispatch({ type: NEW_FORM_PRE_REGISTRATION })
  }
}

export const setPreRegistrationFormTouched = preRegistration => {
  return dispatch => {
    dispatch({ type: FORM_TOUCHED })
  }
}

export const closeModal = () => {
  return dispatch => {
    dispatch({ type: CLOSE_MODAL })
  }
}

export const changeOrderColumn = column => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_COLUMN, column })
  }
}

export const changeOrderDirection = direction => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_DIRECTION, direction })
  }
}

export const resetState = () => {
  return dispatch => {
    dispatch({ type: RESET_STATE })
  }
}

export const handleChangePage = page => {
  return dispatch => {
    dispatch({ type: CHANGE_PAGE, page })
  }
}

export const handleChangePerPage = perPage => {
  return dispatch => {
    dispatch({ type: CHANGE_PER_PAGE, perPage })
  }
}

export const fetchPreRegistrations = options => {
  return dispatch => {
    dispatch({ type: FETCHING_PRE_REGISTRATIONS })

    return API.preRegistrations
      .getPreRegistrations(options)
      .then((res = {}) => {
        const { data } = res

        dispatch({
          type: FETCH_PRE_REGISTRATIONS,
          preRegistrations: data.items,
          length: data.length,
          page: data.page,
          order: data.order,
          rowsPerPage: data.rowsPerPage
        })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data

        dispatch({
          type: FETCH_PRE_REGISTRATIONS_ERROR,
          err: message || 'Serviço indisponível'
        })

        return Promise.reject(err)
      })
  }
}

export const fetchPreRegistration = id => {
  return dispatch => {
    dispatch({ type: FETCHING_PRE_REGISTRATION, clear: true })
    dispatch({ type: OPEN_MODAL })

    return API.preRegistrations
      .getPreRegistration(id)
      .then(({ data }) => {
        dispatch({ type: FETCH_PRE_REGISTRATION, preRegistration: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data

        dispatch({
          type: FETCH_PRE_REGISTRATION_ERROR,
          err: message || 'Serviço indisponível'
        })

        return Promise.reject(err)
      })
  }
}

export const addPreRegistration = preRegistration => {
  const data = formatPreRegistrationToSend.createFormData(preRegistration)

  return dispatch => {
    dispatch({ type: FETCHING_PRE_REGISTRATIONS })
    dispatch({ type: FETCHING_PRE_REGISTRATION })

    return API.preRegistrations
      .addPreRegistration(data)
      .then(response => {
        const { data } = response

        if (data) {
          dispatch({ type: ADD_PRE_REGISTRATION, preRegistration: data })
        }
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data

        handlePreRegistrationError(response, dispatch)

        dispatch({
          type: FETCH_PRE_REGISTRATIONS_ERROR,
          err: message || 'Serviço indisponível'
        })

        return Promise.reject(err)
      })
  }
}

export const editPreRegistration = preRegistration => {
  const { _id = '' } = preRegistration
  const data = formatPreRegistrationToSend.createFormData(preRegistration)

  return dispatch => {
    dispatch({ type: FETCHING_PRE_REGISTRATIONS })
    dispatch({ type: FETCHING_PRE_REGISTRATION })

    return API.preRegistrations
      .editPreRegistration(data, _id)
      .then(({ data }) => {
        dispatch({ type: EDIT_PRE_REGISTRATION, preRegistration: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data

        dispatch({
          type: FETCH_PRE_REGISTRATIONS_ERROR,
          err: message || 'Serviço indisponível'
        })

        handlePreRegistrationError(response, dispatch)

        return Promise.reject(response)
      })
  }
}

export const deletePreRegistration = id => {
  return dispatch => {
    dispatch({ type: FETCHING_PRE_REGISTRATIONS })
    return API.preRegistrations
      .deletePreRegistration(id)
      .then(response => {
        const { data } = response

        dispatch({ type: DELETE_PRE_REGISTRATION, preRegistration: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data

        dispatch({
          type: FETCH_PRE_REGISTRATIONS_ERROR,
          err: message || 'Serviço indisponível'
        })

        return Promise.reject(err)
      })
  }
}

export const restorePreRegistration = id => {
  return dispatch => {
    dispatch({ type: FETCHING_PRE_REGISTRATIONS })

    return API.preRegistrations
      .restorePreRegistration(id)
      .then(({ data }) => {
        dispatch({ type: EDIT_PRE_REGISTRATION, preRegistration: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data

        dispatch({
          type: FETCH_PRE_REGISTRATIONS_ERROR,
          err: message || 'Serviço indisponível'
        })

        handlePreRegistrationError(response, dispatch)

        return Promise.reject(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/preRegistrations.js